import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Box, Stack, Typography } from '@mui/material';
import ErrorScreen from '../../../core-components/theme/components/ErrorScreen';
import Loader from '../../../globalComponents/loader/DPLoader';
import PublicNavbar from '../../../core-components/theme/components/HeaderComponents/PublicNavbar';
import PublicInsightDetailsPage from './PublicInsightDetailsPage';
import { useTranslation } from 'react-i18next';

const PublicInsightDetailsView: React.FC = () => {
  const { t } = useTranslation();
  return (
    <ErrorBoundary fallback={<ErrorScreen />}>
      <Box sx={{ width: '100vw', height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <PublicNavbar />
        <Box sx={{ flex: 1, overflow: 'auto', mt: '64px', display: 'flex', flexDirection: 'column' }}>
          <Suspense
            fallback={
              <Stack direction="column" spacing={3} sx={{ p: 3, flex: 1, display: 'flex' }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Typography variant="title">{t('breadcrumbs.Insight Details', 'Insight Details')}</Typography>
                </Stack>
                <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Loader />
                </Box>
              </Stack>
            }
          >
            <PublicInsightDetailsPage />
          </Suspense>
        </Box>
      </Box>
    </ErrorBoundary>
  );
};

export default PublicInsightDetailsView;
